export default __webpack_public_path__ + "static/media/stats.f096e041.svg";